import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ListChecks, MessageCircleHeart, ScrollText } from 'lucide-react';
const items = [{
  icon: FileText,
  title: 'Guía completa de 7 días'
}, {
  icon: ListChecks,
  title: 'Checklists imprimibles (12/20/30 min)'
}, {
  icon: MessageCircleHeart,
  title: 'Tarjetas de prompts (Cero cringe)'
}, {
  icon: ScrollText,
  title: 'Guiones de invitación'
}];
export function Deliverables() {
  return <section className="py-12 px-4 bg-[#0f0f16]" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-3">
          <h2 className="text-2xl font-serif text-white" data-id="element-4">Qué incluye</h2>
        </motion.div>

        <div className="grid grid-cols-2 gap-3" data-id="element-5">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-4 rounded-xl bg-[#1a1a24] border border-white/5 text-center" data-id="element-6">
              <div className="w-10 h-10 rounded-full bg-[#ff2d7a]/10 flex items-center justify-center mx-auto mb-3" data-id="element-7">
                <item.icon size={20} className="text-[#ff2d7a]" data-id="element-8" />
              </div>
              <p className="text-gray-300 text-sm font-medium" data-id="element-9">{item.title}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}